var React = require('react');
var labels = require('MemberJoinLabels');
var { $nextButton } = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/Validation/ValidationComponents.jsx');

class ChangeStepButtons extends React.Component {
    constructor(props) {
        super(props);

        this.getNextButton = this.getNextButton.bind(this);
        this.goPdfApplication = this.goPdfApplication.bind(this);
    }

    goPdfApplication(event) {
        event.preventDefault();
        window.location = this.props.pdfLink;
    }

    getNextButton() {
        if (this.props.isPdf) {
            return <button onClick={this.goPdfApplication}>{labels.nextPdfApplication}</button>;
        } else {
            const valid = this.props.nextStepValid() && !this.props.disableUI;
            return <$nextButton isvalid={valid.toString()}>{this.props.nextLabel ? this.props.nextLabel : labels.nextStep}</$nextButton>;
        }
    }

    render() {
        const prevButton = this.props.prevStepValid() && !this.props.disableUI
            ? <button onClick={this.props.goPrevStep}>{this.props.backLabel ? this.props.backLabel : labels.back}</button>
            : <button className={"disabled"} disabled>{this.props.backLabel ? this.props.backLabel : labels.back}</button>;

        const nextButton = this.getNextButton();

        return <div className={"change-step-container"}>
            {nextButton}
            {prevButton}
        </div>;
    }
}

module.exports = ChangeStepButtons;